/**
 * Founder Control Center v2 · Operations · Centros (unificado).
 *
 * Fusión visual de Organizaciones (clientes SaaS) + Directorio (alta · revisión ·
 * Discover OSM/RASIC · CSV · enrich · duplicados), tal como exige V2 spec §5.2.
 *
 * Implementación: reutiliza 100% la lógica existente embebiendo dos tabs del
 * SuperAdmin legacy (`orgs` y `directory`). 0 backend tocado. 0 endpoints nuevos.
 * 0 lógica duplicada. Las 35+ acciones del Directorio (Discover, Import, Approve,
 * Reject, Bulk, Enrich, Duplicates, etc.) se preservan tal cual.
 *
 * Dependencia SuperAdmin (intencional): pendiente de eliminar en Fases 7-8 una
 * vez que `DirectoryPanel` y el bloque `orgs` se extraigan del monolito SA.
 */
import { useState } from "react";
import { Buildings, MapPin } from "@phosphor-icons/react";
import SuperAdmin from "../SuperAdmin";

const INNER_TABS = [
  { key: "orgs",      label: "Organizaciones", icon: Buildings,
    sub: "Clientes SaaS · lifetime · suspend · delete" },
  { key: "directory", label: "Directorio",     icon: MapPin,
    sub: "Alta · cola revisión · Discover · Import · Enrich" },
];

export default function CentrosUnified() {
  const [inner, setInner] = useState("orgs");
  return (
    <div className="space-y-4" data-testid="centros-unified-root">
      <div className="flex flex-wrap gap-2 border-b border-[var(--ag-border)] pb-1" data-testid="centros-inner-tabs">
        {INNER_TABS.map((t) => {
          const Icon = t.icon;
          const active = inner === t.key;
          return (
            <button
              key={t.key}
              type="button"
              onClick={() => setInner(t.key)}
              data-testid={`centros-inner-tab-${t.key}`}
              className={`group flex items-center gap-2 px-3 py-2 text-xs rounded-t-sm border-b-2 transition-colors ${
                active
                  ? "border-[var(--ag-gold)] text-[var(--ag-gold)] bg-[var(--ag-gold)]/5"
                  : "border-transparent text-[var(--ag-text-dim)] hover:text-[var(--ag-text)] hover:bg-[var(--ag-surface)]"
              }`}
            >
              <Icon size={14} weight={active ? "fill" : "duotone"} />
              <span className="font-bold uppercase tracking-wider">{t.label}</span>
              <span className="hidden md:inline text-[10px] normal-case font-normal opacity-70 ml-1">· {t.sub}</span>
            </button>
          );
        })}
      </div>
      <div data-testid={`centros-inner-content-${inner}`}>
        <SuperAdmin embedded forceTab={inner === "orgs" ? "orgs" : "directory"} />
      </div>
    </div>
  );
}
